import { render, staticRenderFns } from "./PromoControlsPage.vue?vue&type=template&id=f856473c"
import script from "./PromoControlsPage.vue?vue&type=script&lang=js"
export * from "./PromoControlsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports